<template>
  <OmitInline :element="inline">
    <span :class="inline.style">{{inline.value}}</span>
  </OmitInline>
</template>

<script>
import OmitInline from "@/components/document/fill/OmitInline";
export default {
  name: "Inline",
  props: ["inline"],
  components: {
    OmitInline
  }
};
</script>
